import produce from 'immer';

const INITIAL_STATE = {
  list: [],
  registry: {},
  loading: false,
  saving: false,
  error: false
};

export default function taskPlanning(state = INITIAL_STATE, action) {
  switch (action.type) {
    case '@taskPlannings/INDEX_REQUEST':
    case '@taskPlannings/DELETE_REQUEST':
      return produce(state, draft => {
        draft.loading = true;
        draft.error = false;
      });

    case '@taskPlannings/CREATE_REQUEST':
    case '@taskPlannings/UPDATE_REQUEST':
      return produce(state, draft => {
        draft.saving = true;
        draft.error = false;
      });

    case '@taskPlannings/READ_REQUEST':
      return produce(state, draft => {
        draft.loading = true;
        draft.error = false;
      });

    case '@taskPlannings/CREATE_SUCCESS':
    case '@taskPlannings/UPDATE_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.saving = false;
        draft.registry = action.payload.data;
      });

    case '@taskPlannings/DELETE_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.saving = false;
      });

    case '@taskPlannings/INDEX_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.list = action.payload.data;
      });

    case '@taskPlannings/READ_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.error = false;
        draft.registry = action.payload.data;
      });

    case '@taskPlannings/INDEX_FAILURE':
    case '@taskPlannings/CREATE_FAILURE':
    case '@taskPlannings/UPDATE_FAILURE':
    case '@taskPlannings/DELETE_FAILURE':
      return produce(state, draft => {
        draft.loading = false;
        draft.error = true;
        draft.saving = false;
      });

    case '@taskPlannings/READ_FAILURE':
      return produce(state, draft => {
        draft.loading = false;
        draft.error = true;
        draft.registry = {};
      });

    default:
      return state;
  }
}
